import { render, staticRenderFns } from "./ModalBlocked.vue?vue&type=template&id=081d1bca&scoped=true"
import script from "./ModalBlocked.vue?vue&type=script&lang=js"
export * from "./ModalBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d1bca",
  null
  
)

export default component.exports